import React, {useEffect, useRef} from 'react';
import {Switch} from "@headlessui/react";
import {clearRequiredFieldError, resetRequiredFieldError} from "../../utils/project-utils.js";
import {useRequiredFieldError} from "../../hooks/use-required-field-error.js";

const InputSwitch = ({className, label, name, disabled, id, onChange, checked, inputRef, title = "", required, invalid = false, classNameLabel}) => {
    const switchRef = useRef(null);
    const isRequired = required || (typeof label === "string" && label.trim().endsWith("*"));
    const labelText = typeof label === "string" ? label.replace(/\s*\*\s*$/, "") : label;
    const requiredFieldInvalid = useRequiredFieldError(switchRef, isRequired);
    const hasRequiredError = !disabled && !checked && (invalid || requiredFieldInvalid);

    useEffect(() => {
        if (isRequired && checked) clearRequiredFieldError(switchRef.current);
    }, [checked]);

    useEffect(() => {
        if (disabled) resetRequiredFieldError(switchRef.current);
    }, [disabled]);

    const setSwitchRef = (element) => {
        switchRef.current = element;

        if (typeof inputRef === "function") inputRef(element);
        else if (inputRef) inputRef.current = element;
    };

    return (
        <div className={[`gap-3 flex items-center text-gray-500 ${disabled ? "cursor-default" : " cursor-pointer"}`, disabled && 'opacity-60', className].join(" ")} title={title}>
            <Switch
                ref={setSwitchRef}
                id={id}
                title={title}
                checked={checked}
                onChange={onChange}
                aria-invalid={hasRequiredError}
                data-required-field={isRequired || undefined}
                 className={`group inline-flex h-4 w-9 items-center rounded-full border transition-[border-color,border-width,background-color] duration-150 ease-out bg-gray-400 ${disabled ? "cursor-default" : " cursor-pointer"} ${hasRequiredError ? "border-[2px] border-[#dc2626]" : "border-transparent"}`}
                disabled={disabled}
            >
                <span className="size-5 translate-x-0 rounded-full bg-white transition group-data-checked:translate-x-4 group-data-checked:bg-blue-500 [box-shadow:0px_2px_1px_-1px_rgba(0,0,0,0.2),_0px_1px_1px_0px_rgba(0,0,0,0.14),_0px_1px_3px_0px_rgba(0,0,0,0.12)]" />
            </Switch>
            <label htmlFor={id} className={[`text-[13px] ${disabled ? "cursor-default" : " cursor-pointer"}`, classNameLabel].join(" ")}>
                {labelText}{isRequired ? <span className="ml-0.5">*</span> : null}
            </label>
        </div>
    );
};

export default InputSwitch;